import axios from 'axios';
import { API_CONFIG } from '../config/api';

const api = axios.create({
  baseURL: API_CONFIG.baseURL,
  timeout: API_CONFIG.timeout || 120000,
  headers: API_CONFIG.headers,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('authToken');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const aiService = {
  draftProgressNote: (data) => api.post('/ai/progress-note-draft', data).then((r) => r.data),
  chartSummary: (data) => api.post('/ai/chart-summary', data).then((r) => r.data),
  billingHint: (data) => api.post('/ai/billing-hint', data).then((r) => r.data),
  carePlanDraft: (data) => api.post('/ai/care-plan-draft', data).then((r) => r.data),
  intakeToFacts: (data) => api.post('/ai/intake-to-facts', data).then((r) => r.data),
};

export default aiService;
